import { useEffect, useState } from "react";
import { getDateTypeList } from "utils/api/lookupApi";
import { OptionRenderType } from "controls/global/stewart-checkbox/StewartAutocompleteWithCheckboxes";

export function useDateTypeOptions(
  subType: string = "PolicyTransaction"
): OptionRenderType[] {
  const [options, setOptions] = useState<OptionRenderType[]>([]);
  useEffect(() => {
    let mounted = true;
    getDateTypeList(subType).then((rows) => {
      if (!mounted) return;
      setOptions(
        rows
          .filter((r) => !!r.DateTypeName && !!r.DateTypeCode)
          .map((r) => ({ label: r.DateTypeName, value: r.DateTypeCode }))
      );
    });
    return () => {
      mounted = false;
    };
  }, [subType]);
  return options;
}
